import { useQuery } from "@tanstack/react-query";
import api from "../utils/axios";

// Mirrors beleef-frontend's apis/marketingPrice.js exactly — same public
// backend endpoint (GET /marketingPrice/:price/:suburb/:postcode takes no
// auth, per routes/v1/user/marketingPrice.js), so no admin-specific backend
// work was needed here.
export const useInternetPortalPricing = (price, suburb, postcode, options = {}) => {
  return useQuery({
    queryKey: ["internetPortalPricing", price, suburb, postcode],
    queryFn: async () => {
      const res = await api.get(`/marketingPrice/${price}/${suburb}/${postcode}`);
      return res.data;
    },
    enabled: !!(price && suburb && postcode),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
